<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Edit Tax Rate</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <form (submit)="handleSave()">

  <div class="modal-body">
    <div class="form-group">
      <label for="nameInput">Name</label>
      <input id="nameInput" type="text" class="form-control" name="name"
             required
             [(ngModel)]="taxRate.name">
      <small class="form-text text-muted">
        This name is for staff use only, and is not displayed to the customer.
      </small>
      <div class="form-text text-danger">{{ errors.name }}</div>
    </div>
    <div class="form-group">
      <label for="rateInput">Rate</label>
      <div class="input-group">
        <input id="rateInput" type="number" class="form-control" name="rate_percent"
               required min="0" max="100" step="0.001" placeholder="X.XXX"
               [(ngModel)]="taxRate.rate_percent">
        <div class="input-group-append">
          <span class="input-group-text">%</span>
        </div>
      </div>
      <div class="form-text text-danger">{{ errors.rate_percent }}</div>
    </div>

    <div class="alert alert-danger" role="alert" *ngIf="errors.non_field_errors">
      {{ errors.non_field_errors }}
    </div>
    <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="submit" class="btn btn-primary"
            *ngIf="!loadingSubmit">
      Save
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loadingSubmit">
      Loading...
    </button>
  </div>

  </form>

</ng-container>
